import { render } from "./PremierFlooring.vue?vue&type=template&id=47bb5ffc&scoped=true"
import script from "./PremierFlooring.vue?vue&type=script&lang=js"
export * from "./PremierFlooring.vue?vue&type=script&lang=js"

import "./PremierFlooring.vue?vue&type=style&index=0&id=47bb5ffc&scoped=true&lang=css"

import exportComponent from "/home/ubuntu/www/releases/20260911022515/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-47bb5ffc"]])

export default __exports__